<template>
<v-container fluid class="pa-0">
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title >
            <span>Secteur</span>
            <v-spacer></v-spacer>
            <v-chip outlined color="secondary" v-if="item.ass_updated_at">
                    <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.ass_updated_at).format('DD MMMM YYYY') }}
            </v-chip>
        </v-card-title>
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field label="Nom"  v-model="item.zon_name"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pr-2">
                <v-select 
                item-text="sta_label" item-value="sta_id"
                :items="stateListByGroup['GEN']" v-model="item.zon_sta_id" label="Statut" single-line >
            </v-select>
            </v-col>
            <v-col cols="12" md="6" class="pr-2">
            <AutocompleteMulti 
                    :title="'Responsable zone'" :ressource="'users'" ref="zonOwner"
                    :listObject.sync="item.zon_usr_id" :listParent.sync="autoCompleteSource.userList"
                    :fields="{ 
                        index: 'id', text:'middleName', autofocus: true, dense: true, resultlimit: 25,
                        search:'usr_middleName', multiSelect:false, prefetch: true, params:'usr_role=ADMIN_USER,SUPER_USER,WORK_SUPERVISOR,TEAM_LEADER,AGENT&', notfound: '-- introuvable --'
                    }"/>
            </v-col>
            <v-col cols="3" md="3" class="pa-1">
                <v-menu offset-y content-class="elevation-0" style="z-index:900">
                    <template v-slot:activator="{ on }">
                        <v-btn :color="item.zon_color" block dark class="mt-3" v-on="on">Couleur</v-btn>
                    </template>
                    <v-color-picker v-model="item.zon_color" class="ma-2 elevation-0" hide-canvas :swatches="swatches" show-swatches></v-color-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="6" class="pr-2"></v-col>
        </v-row>
    </v-card>
    <v-toolbar extended flat color="transparent" class="elevation-0" >
        <v-btn :disabled="!item.zon_id" rounded color="error" @click.native="deleteForm()"><v-icon left dark>mdi-close</v-icon>Supprimer</v-btn>
        <v-spacer></v-spacer>
        <v-btn rounded text href="/#/zones/"><v-icon left dark>mdi-close</v-icon>Annuler</v-btn>
        <v-btn rounded color="success" class="ml-3" :loading="saveProgress" @click.native="saveForm()" :disabled="saveProgress">
            <v-icon left dark>mdi-content-save-outline</v-icon>Enregistrer
        </v-btn>
    </v-toolbar>
</v-container>
</template>

<script>
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

import { mapState, mapActions, mapWritableState } from 'pinia'

import { useZoneStore } from '@/stores/zone'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'

export default {
    name: 'zone-edit',
    props: [ 'contextStyle'],
    components: { AutocompleteMulti },
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            loadingData: true,
            swatches: [
                ['#FF0000', '#AA0000', '#550000'], ['#FFFF00', '#AAAA00', '#555500'], ['#00FF00', '#00AA00', '#005500'],
                ['#00FFFF', '#00AAAA', '#005555'], ['#0000FF', '#0000AA', '#000055'],
            ],
            autoCompleteSource: { userList: [], },
        }
    },
    computed: {
        ...mapWritableState(useZoneStore, {item: 'item', correctedTag: 'correctedTag' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
    },
    beforeMount: function(){},
    mounted:function (){
        if( ( this.$route.params.zon_id ) && this.$route.params.zon_id > 0 ){
            this.fetchItem(this.$route.params.zon_id)
            this.loadingData = false
        } else {
            this.initItem()
            this.loadingData = false
        }
    },
    methods: {
        ...mapActions(useZoneStore, {fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', deleteItem: 'deleteItem', initItem: 'RESET_ITEM'}),
        async getForm(){
            this.fetchItem()
            this.loadingData = false
            
        },
        async saveForm () {
            if( !this.item.zon_id ){
                await this.storeItem()
                this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                this.$router.push({ path: '/zones' })
            } else {
                await this.updateItem()
                this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                this.$router.push({ path: '/zones' })
            }
        },
        async deleteForm(){
            await this.deleteItem()
            this.$root.$toast({ color: 'success', text: 'Fiche supprimée !' })
            this.$router.push({ path: '/zones' })
        },
    }
}
</script>